import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=9120dd12"
import script from "./sku.vue?vue&type=script&lang=js"
export * from "./sku.vue?vue&type=script&lang=js"
import style0 from "./sku.vue?vue&type=style&index=0&id=9120dd12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports